import { updateServiceConfig } from "owa-service/lib/config";

export function setDisableAllRequests(value: boolean): void {
    updateServiceConfig({ disableAllRequests: value });
}
